import Sentry from '@Utils/Sentry'

import { createRoot } from 'react-dom/client'
import '@shopify/polaris/build/esm/styles.css'
import App from './App'

try {
  const host = new URLSearchParams(location.search).get('host') as string

  if (host) {
    new Sentry()

    createRoot(document.getElementById('root')!).render(<App />)
  } else {
    window.location.href = 'https://apps.shopify.com/prisync-ai-dynamic-pricing'
  }
} catch (e) {
  console.error(e)
}
